/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './medication-details.reducer';

export const MedicationDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const medicationDetailsEntity = useAppSelector(state => state.medicationDetails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="medicationDetailsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.medicationDetails.detail.title">MedicationDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.id">Id</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.id}</dd>
          <dt>
            <span id="repetition">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.repetition">Repetition</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.repetition}</dd>
          <dt>
            <span id="tmEnd">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.tmEnd">Tm End</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.tmEnd}</dd>
          <dt>
            <span id="currentSupply">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.currentSupply">Current Supply</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.currentSupply}</dd>
          <dt>
            <span id="refillSize">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.refillSize">Refill Size</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.refillSize}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.timestampentry}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.active">Active</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.microSec}</dd>
          <dt>
            <span id="prescribedCount">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.prescribedCount">Prescribed Count</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.prescribedCount}</dd>
          <dt>
            <span id="indication">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.indication">Indication</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.indication}</dd>
          <dt>
            <span id="daysFrequency">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.daysFrequency">Days Frequency</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.daysFrequency}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.endDate}</dd>
          <dt>
            <span id="dose">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.dose">Dose</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.dose}</dd>
          <dt>
            <span id="route">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.route">Route</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.route}</dd>
          <dt>
            <span id="stopped">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.stopped">Stopped</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.stopped ? 'true' : 'false'}</dd>
          <dt>
            <span id="stoppedBy">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.stoppedBy">Stopped By</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.stoppedBy}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.patientType}</dd>
          <dt>
            <span id="exposed">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.exposed">Exposed</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.exposed ? 'true' : 'false'}</dd>
          <dt>
            <span id="medicineName">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.medicineName">Medicine Name</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.medicineName}</dd>
          <dt>
            <span id="doseInstructions">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.doseInstructions">Dose Instructions</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.doseInstructions}</dd>
          <dt>
            <span id="tmType">
              <Translate contentKey="tinyMedicRestApp.medicationDetails.tmType">Tm Type</Translate>
            </span>
          </dt>
          <dd>{medicationDetailsEntity.tmType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationDetails.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{medicationDetailsEntity.glucoUser ? medicationDetailsEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationDetails.medicine">Medicine</Translate>
          </dt>
          <dd>{medicationDetailsEntity.medicine ? medicationDetailsEntity.medicine.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationDetails.prescription">Prescription</Translate>
          </dt>
          <dd>{medicationDetailsEntity.prescription ? medicationDetailsEntity.prescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationDetails.servedBy">Served By</Translate>
          </dt>
          <dd>{medicationDetailsEntity.servedBy ? medicationDetailsEntity.servedBy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/medication-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/medication-details/${medicationDetailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MedicationDetailsDetail;
